var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.raf || _vm.show,
          expression: "raf || show"
        }
      ],
      staticClass: "_pane _con",
      class: { show: _vm.show },
      style: { width: _vm.width, height: _vm.height },
      attrs: { role: "dialog", dir: _vm.direction },
      on: { touchstart: _vm.touchstart, touchend: _vm.touchend }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }